import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { createDatadogLogsBeforeSend } from './app/utils/datadog-log-sanitizer.util';

import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.amplify_config.userPoolId,
      userPoolClientId: environment.amplify_config.userPoolWebClientId,
    },
  },
});

if (environment.production) {
  enableProdMode();
}
if (environment.env === 'prd' || environment.env === 'uat') {
  datadogRum.init(environment.dataDogConfig);
  if (environment.dataDogLogsConfig?.clientToken) {
    datadogLogs.init({
      ...environment.dataDogLogsConfig,
      beforeSend: createDatadogLogsBeforeSend(environment),
    });
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
